import e from "./SchemaGlyphPuck.vue.script.js";
//#region src/schema/SchemaGlyphPuck.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=SchemaGlyphPuck.vue.js.map